import { useMutation } from "@tanstack/react-query"
import { loginType } from "../types/login"
import { api } from "./client"
import { useAuthStore } from "../store/states/useAuthStore"
import { setToken, setUtente, setAzienda, registerToken, saveAuthStateSnapshot } from "./gisApi"

interface LoginResponse {
  esito: string
  messaggio: string
  token: string
}

const loginRequest = (payload: loginType) =>
  api<LoginResponse>("/loginkc", {
    method: "POST",
    body: JSON.stringify(payload),
  })

export const useLogin = () => {
  const { setAuth } = useAuthStore()
  return useMutation({
    mutationFn: loginRequest,
    onSuccess: async ({ token }, variables) => {
      if (!token) {
        throw new Error("Login: token mancante in risposta")
      }
      // Salva PRIMA utente/azienda (cache + localStorage) così che lo snapshot
      // creato in coda rifletta il contesto corretto del nuovo login.
      setUtente(variables.utente)
      setAzienda(variables.azienda)
      setToken(token) // salva token in cache + localStorage + sincronizza Zustand store
      // Registra il token nel backend (necessario prima che qualsiasi API call parta)
      try {
        await registerToken(token)
      } catch (e) {
        console.warn("registerToken dopo login fallito:", e)
      }
      setAuth(token) // garantisce sync Zustand store (AuthGuard) anche se setToken non l'ha già fatto
      // Aggiorna lo snapshot auth col nuovo contesto utente/azienda → fetchGuard
      // non rileverà falsi positivi di "cambio contesto" alla prima chiamata.
      saveAuthStateSnapshot()
    },
  })
}

export const useLogout = () => {
  const { clearAuth } = useAuthStore()
  return () => clearAuth()
}
